import { React, useState, useEffect, useContext } from 'react';

import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

import { Alerta } from '../../components/alerta';
import PageHeader from '../../components/pageHeader';
import SubmitButton from '../../components/submitButton';
import DadosUsuario from '../../utils/context';
import { fetchFlask } from '../../utils/fetchFlask';

const NovoPedido = () => {
    const dadosUsuario = useContext(DadosUsuario);
    const autorizacoes = dadosUsuario.autorizacoes;
    const [listaMaterial, setListaMaterial] = useState([]);
    const [listSites, setListSites] = useState([]);
    const [site, setSite] = useState('');
    const [material, setMaterial] = useState('');
    const [quantidade, setQuantidade] = useState(0);
    const [obs, setObs] = useState('');
    const [pedido, setPedido] = useState([]);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        async function getmaterials () {
            const response = await fetchFlask('getMaterials');
            if (response.status !== 'error') {
                setListaMaterial(response.material);
            } else {
                setMessage(response.message);
                setStatus(response.status);
                setOpenAlerta(true);
            }

            if (['PedidosOeMGerencial', 'PedidosOeMTecnico', 'Adm'].some(a => autorizacoes.includes(a))) {
                setTimeout(() => {}, 1000);
                const response = await fetchFlask('getSites');
                if (response.status !== 'error') {
                    const sitesArray = response.sites
                    .map(obj => {
                        const key = Object.keys(obj)[0];
                        const value = obj[key];
                        return { key, value };
                    });
                    setListSites(sitesArray);
                } else {
                    setMessage(response.message);
                    setStatus(response.status);
                    setOpenAlerta(true);
                }
            }
        };
        getmaterials();
    }, []);

    const handleAdd = () => {
        if (!material || quantidade < 0) return;

        const novoItem = {
            material: material.material,
            unit: material.unit,
            quantity: Number(quantidade),
            obs
        };

        setPedido([...pedido, novoItem]);
        setMaterial(null);
        setQuantidade('');
        setObs('');
    };

    async function submitNovoPedido (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            pedido,
            siteID: site?.key ?? null
        });

        const response = await fetchFlask('newOrder', body);
        setMessage(response.message);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status === 'success') {
            setPedido([]);
            setSite('');
        }
        setIsSubmit(false);
    };

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <PageHeader>
                Novo Pedido
            </PageHeader>

            <Link to="/">
                <Button>
                    Voltar
                </Button>
            </Link>

            <form action='' method='POST' id='formNewOrder' onSubmit={submitNovoPedido}>
                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <Autocomplete
                        options={listaMaterial}
                        value={material}
                        onChange={(e, newValue) => setMaterial(newValue)}
                        renderInput={(params) => (
                        <TextField {...params} label="Material" variant="outlined" />
                        )}
                        getOptionLabel={(option) => option.material || ''}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        label='Quantidade'
                        type='number'
                        variant='outlined'
                        fullWidth
                        value={quantidade}
                        onChange={(e) => setQuantidade(e.target.value)}
                        InputProps={{
                        endAdornment: material?.unit
                            ? <Typography sx={{ ml: 1 }}>{material.unit}</Typography>
                            : null
                        }}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        label='Observação'
                        variant='outlined'
                        fullWidth
                        value={obs}
                        onChange={(e) => setObs(e.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ marginTop: '20px' }}>
                    <Button
                        variant='contained'
                        color='primary'
                        fullWidth
                        sx={{ height: '100%' }}
                        onClick={handleAdd}
                    >
                        Adicionar
                    </Button>
                </FormControl>

                {pedido.length > 0 && (
                    <>
                        <TableContainer sx={{ mt: 4 }}>
                            <Table>
                            <TableHead>
                                <TableRow>
                                <TableCell>Material</TableCell>
                                <TableCell align='right'>Quantidade</TableCell>
                                <TableCell align='center'>Unidade</TableCell>
                                <TableCell align='left'>Obs</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {pedido.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell>{item.material}</TableCell>
                                    <TableCell align='right'>{item.quantity}</TableCell>
                                    <TableCell align='center'>{item.unit}</TableCell>
                                    <TableCell align='left'>{item.obs}</TableCell>
                                </TableRow>
                                ))}
                            </TableBody>
                            </Table>
                        </TableContainer>

                        {(['PedidosOeMGerencial', 'PedidosOeMTecnico'].some(a => autorizacoes.includes(a))) && (
                            <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                                <InputLabel id='labelSite'>Site</InputLabel>
                                <Select
                                    id='Site'
                                    labelId='labelSite'
                                    label='Site'
                                    value={site}
                                    onChange={(e) => setSite(e.target.value)}
                                    sx={{ width: '100%' }}
                                    required
                                >
                                    {listSites.map((item) => (
                                        <MenuItem key={item.key} value={item} >
                                            {item.value}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        )}

                        <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                            <SubmitButton isSubmit={isSubmit} >Enviar Pedido</SubmitButton>
                        </FormControl>
                    </>
            )}
            </form>
        </Box>
    );
};

export default NovoPedido;
